"use client"

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { getUserSession } from "../redux/slices/authSlice"

const MAX_ALLOWED_DEVICES = 2

const SessionCheck = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    const checkSessions = async () => {
      // Fetch user sessions
      const result = await dispatch(getUserSession())

      if (getUserSession.fulfilled.match(result)) {
        // Check if user has more sessions than allowed
        const sessionCount = result.payload?.data?.sessions?.length || result.payload?.sessions?.length || 0

        if (sessionCount > MAX_ALLOWED_DEVICES) {
          // User has too many sessions - redirect to conflict screen
          navigate("/session-conflict", { replace: true })
        } else {
          // User is within limit - redirect to dashboard
          navigate("/dashboard", { replace: true })
        }
      } else {
        // Error fetching sessions - redirect to dashboard anyway
        navigate("/dashboard", { replace: true })
      }
    }

    checkSessions()
  }, [dispatch, navigate])

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="text-center">
        <div className="spinner-border lg text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <h4 className="text-lg mb-1">Please wait...</h4>
        <p className="text-16 text-muted">We are verifying your device access</p>
      </div>
    </div>
  )
}

export default SessionCheck
